export const uploadImage = async (file) => {
  try {
    if (!file.type.startsWith('image/')) {
      return { success: false, error: 'Please select an image file' };
    }

    if (file.size > 5 * 1024 * 1024) {
      return { success: false, error: 'Image must be less than 5MB' };
    }

    const formData = new FormData();
    formData.append('image', file);

    // Use MAMP during development
    const uploadUrl = window.location.hostname === 'localhost'
      ? 'http://localhost:8888/upload.php'
      : '/upload.php';

    const response = await fetch(uploadUrl, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      return { success: false, error: 'Upload failed: Server error' };
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Upload error:', error);
    return { success: false, error: 'Upload failed: ' + error.message };
  }
};